/* eslint-disable no-param-reassign */
import Axios from 'axios';
import Cookies from 'js-cookie';
import { config } from '../config';
import { Helper } from './helper';
import aegis from '@/utils/aegis.js';

const is = {
  // http错误
  httpError: res => res.status !== 200,
  // 接入层错误
  accessLayerError: res => res.status === 200 && res.data.ret !== 0,
  // 鉴权层
  authLayerError: res => res.status === 200 && res.data.ret === 0 && res.data.data.ret !== 0,
};

const createResponse = (code, msg = '未知错误', data = null) => ({
  code,
  msg,
  data,
});

const axios = Axios.create({
  timeout: 20000,
  withCredentials: true,
  headers: {
    'Content-Type': 'text/plain',
  },
});

axios.interceptors.request.use(
  (data) => {
    const {
      method,
      body,
      authType,
      authOptions = {},
    } = data.data;

    data.data = {
      // 鉴权信息
      authOptions: JSON.stringify({
        token: Cookies.get('eBusinessToken'),
        type: authType || 'pc',
        ...authOptions,
      }),
      method,
      body: JSON.stringify(body),
      url: data.url,
    };

    if (Helper.getParameterByName('env')) {
      Cookies.set(
        'env',
        `${Helper.getParameterByName('env')}`,
        { expires: 365, path: '' },
      );
    }

    if (Cookies.get('env')) {
      data.data.authOptions = JSON.stringify({
        env: Cookies.get('env'),
        ...JSON.parse(data.data.authOptions),
      });
    }

    data.url = `${config.apiBaseUrl}?url=${data.url}`;

    return data;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(
  (res) => {
    // 接口请求信息上报，用于观测是否还有老接口的请求
    aegis.reportApi(`url: ${res?.config?.url} \n\nreq param: ${res?.config?.data} \n\nres data: ${JSON.stringify(res?.data)}`);

    const {
      resp,
      ret,
      msg,
    } = res.data.data;

    if (is.httpError(res)) {
      return createResponse(res.status, 'HTTP请求错误');
    }

    if (is.accessLayerError(res)) {
      return createResponse(res.data.ret, '接入层错误');
    }

    if (is.authLayerError(res)) {
      const authErrorCodes = [-1000, -1001];
      const code = parseInt(ret, 10);

      if (authErrorCodes.includes(code)) {
        console.log(window.$router);
        Helper.removeLoginInfo();
        window.location.href = `${config.loginUrl}`;
        return createResponse(-1, '跳转登录');
      }

      return createResponse(ret, msg);
    }

    let response;
    if (typeof resp === 'string') {
      try {
        response = JSON.parse(resp);
      } catch (e) {
        response = null;
      }
    }

    const {
      status,
      message,
    } = response.base;
    return response ? createResponse(status, message, response.result) : {};
  },
  (err) => {
    console.log(`请求出错 ${err}`);
    return err;
  },
);

export default axios;
